<template>
  <div :class="filterListingCssClasses">
    <h2 id="filter-title-toggle" class="filter-title">
      <button
        class="reset-button-style"
        @click="onFilterTitleClick"
      >
        Refine by
      </button>
      <i
        id="candle-caret"
        :class="caretCssClasses"
      />
    </h2>
    <search-filters
      css-prefix="dedicated"
      @change="onFilterChange"
    />
  </div>
</template>

<script>
  import SearchFilters from '../storefront/search-form/filters';

  export default {
    components: {
      SearchFilters
    },
    data() {
      return {
        displayFiltersOnMobile: false
      }
    },
    computed: {
      filterListingCssClasses() {
        return this.displayFiltersOnMobile ? "filter-listing" : "filter-listing hide-on-mobile";
      },
      caretCssClasses() {
        const constantClasses = "candlescience-caret";
        if (this.displayFiltersOnMobile) {
          return `${constantClasses} caret-up`;
        }
        return `${constantClasses} caret-down`;
      }
    },
    methods: {
      onFilterTitleClick() {
        this.displayFiltersOnMobile = !this.displayFiltersOnMobile;
      },
      onFilterChange(payload) {
        this.$emit('change', payload)
      }
    }
  };
</script>
